import { useEffect, useState } from "react";

const AnalysisPanelItem = (props) => {
  const [subSection, setSubSection] = useState("");

  const handleSectionClick = (header) => {
    if (props.data?.length) {
      setSubSection(props.data[0].label);
      if (typeof props.data[0].value === "object") {
        props.handleClick(
          header,
          props.data[0].value.file,
          props?.violation ? props?.violation : ""
        );
      } else {
        props.handleClick(
          header,
          props.data[0].file,
          props?.violation ? props?.violation : ""
        );
      }
    } else {
      console.log("Empty section " + header);
    }
  };

  const handleSubPanelClick = (index) => {
    setSubSection(props.data[index].label);
    props.handleClick(
      props.header,
      props.data[index].value.file || props.data[index].file || props.data[0].value.file,
      props?.violation ? props?.violation : ""
    );
  };

  return (
    <div className="list-container" style={{ cursor: "pointer" }}>
      <div
        className={
          !props.isExpand ? "panel-header" : "panel-header collapse-item"
        }
        onClick={() => {
          handleSectionClick(props.header);
        }}
      >
        <h4 className="data-list">{props.header}</h4>
        <div>
          {props.violation ? <span className="violation-icon"></span> : ""}
          <span
            className={!props.isExpand ? "caret down" : "panel-header caret up"}
          ></span>
        </div>
      </div>

      <div className={`data-list ${!props.isExpand ? "collapsed" : ""}`}>
        {props.data?.length
          ? props.data?.map((item, index) => {
              if (item) {
                if (typeof item.value !== "object") {
                  return (
                    <div className="data-item">
                      <span> <strong> {item.label} </strong> </span>
                      <span className="value"> {item.value} </span>
                    </div>
                  );
                }
                return (
                  <div className="build-info">
                    <span
                      className={
                        item.label === subSection
                          ? "sub-heading active"
                          : "sub-heading"
                      }
                      onClick={(e) => {
                        handleSubPanelClick(index);
                      }}
                    >
                      {item.label}
                    </span>
                    <div className="data-item">
                      <span> Area </span>
                      <span className="value">{item.value?.area || "--"}</span>
                    </div>
                    <div className="data-item">
                      <span> Area (%) </span>
                      <span className="value">
                        {Object.keys(item.value).length
                          ? item.value[Object.keys(item.value)[1]]
                          : "--"}
                      </span>
                    </div>
                  </div>
                );
              }
              return <div></div>;
            })
          : "No data avaiable"}

        {props.violation ? (
          <div className="violation">
            <span className="heading">{props.header}</span>
            <span>{props.violation}</span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default AnalysisPanelItem;
